import React, { useRef, useEffect, useState } from 'react';
import HumanModelLogic from './script'; // Adjust the path if necessary
import Treatments from '../../assets/json/treatments.json'; // Adjust the JSON import path if necessary
import Lottie from 'react-lottie';
import animationData from '../../assets/json/drag-and-drop.json'; // Replace 'your-animation.json' with the path to your Lottie animation JSON file
import ContactModal from '../ContactModal';

function HumanBody({prenota}) {
  const canvasRef = useRef(null);
  const [shoulderPress, setShoulderPress] = useState('Lorem ipsum dolor sit amet consectetur adipisicing elit. Et, sequi? Facere voluptatum iure enim! Ut maiores itaque molestiae eligendi explicabo accusantium hic dolores esse. Sunt tenetur esse aut blanditiis hic.');
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedTreatments, setSelectedTreatments] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [contactModal, setContactModal] = useState(false);


  const openContactModal = () => {
    setContactModal(true);
  };

  const closeContactModal = () => {
    setContactModal(false);
  };

  const defaultOptionsDAD = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const handleSelectedSection = (section) => {
    setShoulderPress(`${section}`);
    setSelectedSection(section);
  };

  const handleHovered = (section) => {
    if(section){
      // setIsHovered(true);
    }
  };

  useEffect(() => {
    HumanModelLogic({ handleSelectedSection, handleHovered });
    return () => {};
  }, []);

  useEffect(() => {
    if (selectedSection) {
      let treatmentsFound = false;

      // Loop through each section in Treatments to find the matching ID
      Treatments.forEach((section) => {
        if (section.id === selectedSection) {
          setSelectedTreatments(section.conditions);          
          setBackgroundImage(section.image); 
          setSelectedRegion(section.region);
          
          treatmentsFound = true;
        }
      });

      if (!treatmentsFound) {
        setSelectedTreatments([]);
        setBackgroundImage('');
      }
    }
  }, [selectedSection]);

  return (
    <div className="flex">
      {selectedRegion === '' && !isHovered && 
        <>
          <div className='z-40 right-0 absolute me-[35rem] mt-[26rem]'>
            <Lottie
              options={defaultOptionsDAD}
              height={250}
              width={250}
            />
          </div>
        </>
      }
      {/* Canvas Section */}
      <div className="w-2/5 h-screen sticky top-0 overflow-hidden pt-16">
        <canvas ref={canvasRef} className="webgl w-full h-full" id='canvasModel' />
      </div>
      {/* Content Section */}
      <div className="w-3/5 relative flex flex-col items-center overflow-auto bg-mcare">
        {/* Background Image */}
        {/* {backgroundImage && (
          <img 
            src={backgroundImage} 
            alt="Treatment Background" 
            className="absolute inset-0 w-full h-full object-cover" 
          />
        )} */}
        <div className="w-full h-full inset-0 glassmorphism-trattamenti">
          <div className="relative text-white h-full pt-64 text-center flex flex-col items-center">
            <div className="text-left mb-8 w-full max-w-2xl px-5">
              <h1 className="text-4xl font-bold text-[#65806E] mt-30 mb-5 uppercase panoragraf-light">{selectedRegion === '' ? 'Interagisci con il Modello 3D' : selectedRegion}</h1>
              {selectedRegion === '' && 
              <p className="text-lg mb-8">
                Clicca su una delle aree del corpo sul modello 3D a sinistra per scoprire tutti i trattamenti disponibili per quella zona. Esplora le opzioni e scegli il trattamento più adatto alle tue esigenze!
              </p>
              }
              {selectedRegion !== '' && <h2 className="text-2xl font-semibold mb-5">Trattamenti</h2>}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {selectedTreatments.map((condition, index) => (
                  <div key={index} className="mb-4">
                    <h3 className="font-semibold mb-5 ">{condition.name}:</h3>
                    <ul className="list-disc pl-5">
                      {condition.treatments.map((treatment, idx) => (
                        <li key={idx}>{treatment}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              {selectedRegion !== '' && 
                <button className="w-full px-8 py-2 mt-10 mb-20 progress-button-mcare" onClick={prenota}>
                  Prenota una consulenza
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HumanBody;
